import type { DifficultyId } from '../game/combat/types/primitives'
import { DIFFICULTY_IDS } from '../game/combat/types/primitives'

const STORAGE_KEY = 'shapes-td.difficulty.v1'
const DEFAULT: DifficultyId = 'normal'

function isDifficultyId(value: unknown): value is DifficultyId {
  return typeof value === 'string' && (DIFFICULTY_IDS as readonly string[]).includes(value)
}

export function createDifficultyPreferenceStore(storage?: Storage) {
  const resolve = (): Storage | null => {
    if (storage) return storage
    if (typeof localStorage === 'undefined') return null
    return localStorage
  }

  return {
    load(): DifficultyId {
      const backend = resolve()
      if (!backend) return DEFAULT
      try {
        const raw = backend.getItem(STORAGE_KEY)
        if (!raw) return DEFAULT
        const parsed = JSON.parse(raw) as unknown
        if (isDifficultyId(parsed)) return parsed
        if (parsed && typeof parsed === 'object' && isDifficultyId((parsed as { id?: unknown }).id)) {
          return (parsed as { id: DifficultyId }).id
        }
        return DEFAULT
      } catch {
        return DEFAULT
      }
    },

    save(id: DifficultyId): void {
      const backend = resolve()
      if (!backend) return
      try {
        backend.setItem(STORAGE_KEY, JSON.stringify(id))
      } catch {
        // ignore quota
      }
    }
  }
}

export const difficultyPreference = createDifficultyPreferenceStore()
